import { createFileRoute } from "@tanstack/react-router";
import { CallingInterface } from "@/components/phone-banking/CallingInterface";

export const Route = createFileRoute(
	"/_app/_/phone-banking/$campaignId/call",
)({
	component: PhoneBankingCallPage,
});

function PhoneBankingCallPage() {
	const { campaignId } = Route.useParams();
	return (
		<div className="h-full p-6">
			<CallingInterface phoneCampaignId={Number(campaignId)} />
		</div>
	)
}
